import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "report-questions-comp" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Questions and Answers", -1)
const _hoisted_3 = { class: "questions-container" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "printable" }
const _hoisted_6 = { class: "answers" }
const _hoisted_7 = { class: "time" }
const _hoisted_8 = { class: "answer-block" }
const _hoisted_9 = { class: "question" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", null, "Question:", -1)
const _hoisted_11 = { class: "answer" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", null, "Answer:", -1)
const _hoisted_13 = {
  key: 0,
  class: "attachment"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, "Attachments:", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_AnswersTable = _resolveComponent("AnswersTable")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_tag = _resolveComponent("tag")
  const _component_el_collapse = _resolveComponent("el-collapse")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", null, [
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode("div", null, [
          _createVNode(_component_el_input, {
            placeholder: "Search",
            onInput: _ctx.updateQuery,
            modelValue: _ctx.searchQuery,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchQuery = $event))
          }, null, 8, ["onInput", "modelValue"])
        ], 512), [
          [_vShow, _ctx.isPrinting === false]
        ]),
        (_ctx.searchQuery)
          ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_AnswersTable, { answers: _ctx.searchResults }, null, 8, ["answers"])
            ], 512)), [
              [_vShow, _ctx.isPrinting === false]
            ])
          : (_openBlock(), _createBlock(_component_el_collapse, {
              key: 1,
              modelValue: _ctx.openSections,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.openSections = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(Object.keys(_ctx.sections).sort(), (section) => {
                  return (_openBlock(), _createBlock(_component_tag, {
                    is: _ctx.tag,
                    key: section,
                    id: section,
                    name: section
                  }, {
                    title: _withCtx(() => [
                      _createVNode("h1", null, [
                        _createVNode("i", {
                          class: 
                    `el-icon-arrow-right animated ${
                      _ctx.openSections.includes(section) ? 'rot-90' : ''
                    }`
                  
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(section), 1)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_el_tabs, { type: "border-card" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sections[section], (answers, group) => {
                            return (_openBlock(), _createBlock(_component_el_tab_pane, {
                              class: "question-group",
                              key: group,
                              label: group
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AnswersTable, {
                                  answers: answers,
                                  isPrinting: _ctx.isPrinting
                                }, null, 8, ["answers", "isPrinting"])
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1536), [
                        [_vShow, _ctx.isPrinting === false]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_5, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sections[section], (answers, group) => {
                          return (_openBlock(), _createBlock("div", {
                            key: group,
                            class: "group"
                          }, [
                            _createVNode("h2", null, _toDisplayString(group), 1),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(answers, (answer) => {
                              return (_openBlock(), _createBlock("div", _hoisted_6, [
                                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.convertDateString( answer?.created ?? '',_ctx.userPrefs?.timezone ?? 0,)), 1),
                                _createVNode("div", _hoisted_8, [
                                  _createVNode("div", _hoisted_9, [
                                    _hoisted_10,
                                    _createVNode("span", null, _toDisplayString(answer.question.question), 1)
                                  ]),
                                  _createVNode("div", _hoisted_11, [
                                    _hoisted_12,
                                    _createVNode("span", null, _toDisplayString(answer.answer), 1)
                                  ]),
                                  (answer.files.length > 0)
                                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                                        _hoisted_14,
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(answer.files, (file) => {
                                          return (_openBlock(), _createBlock("div", {
                                            key: file.id
                                          }, [
                                            _createVNode("span", null, _toDisplayString(file.name), 1),
                                            (file.mime_type.includes('image'))
                                              ? (_openBlock(), _createBlock("img", {
                                                  key: 0,
                                                  src: file.url,
                                                  width: "300",
                                                  class: "preview-img"
                                                }, null, 8, ["src"]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _hoisted_15
                              ]))
                            }), 256))
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, _ctx.isPrinting === true]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["is", "id", "name"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]))
      ])
    ])
  ]))
}